import { UserConstant } from '../constants';
import { RequestAction } from '.';

export const changePassword = (id, data) =>
  RequestAction.request(UserConstant.CHANGE_PASSWORD_USER, {
    data,
    method: 'put',
    url: `/api/user/${id}/change-password`,
  });

export const createUser = data =>
  RequestAction.request(UserConstant.CREATE_USER, {
    data,
    method: 'post',
    url: `/api/user`,
  });

export const deleteUser = id =>
  RequestAction.request(UserConstant.DELETE_USER, {
    method: 'delete',
    url: `/api/user/${id}`,
  });

export const editUser = (id, data) =>
  RequestAction.request(UserConstant.EDIT_USER, {
    data,
    method: 'put',
    url: `/api/user/${id}`,
  });

export const getUser = id =>
  RequestAction.request(UserConstant.GET_USER, { url: `/api/user/${id}` });

export const getUsers = params =>
  RequestAction.request(UserConstant.GET_USERS, { params, url: '/api/user' }, false);

export const setUser = payload => ({
  payload,
  type: UserConstant.SET_USER,
});

export const setUsers = payload => ({
  payload,
  type: UserConstant.SET_USERS,
});
